import React from 'react';
import { motion } from 'framer-motion';
const SCENES = [{
  emoji: '🌙',
  text: 'Dormir 6–7 horas sin despertarte sobresaltada a las 3am'
}, {
  emoji: '💼',
  text: 'Ir a una reunión sin presión en el pecho antes de entrar'
}, {
  emoji: '📱',
  text: 'No revisar el celular cada 2 minutos esperando algo malo'
}, {
  emoji: '🍽️',
  text: 'Sentarte a cenar sin tensión en la mandíbula'
}, {
  emoji: '☀️',
  text: 'Despertar y que tu primer pensamiento no sea ansiedad'
}, {
  emoji: '🫁',
  text: 'Respirar profundo sin tener que "intentarlo"'
}];
export function ForYouSection() {
  return <section className="py-20 bg-[#9B4D4D] px-4 text-white" data-id="element-85">
      <div className="max-w-4xl mx-auto" data-id="element-86">
        <div className="text-center mb-14" data-id="element-87">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-88">
            Así se ve tu vida cuando sales del modo alerta
          </h2>
          <p className="text-white/70 text-lg" data-id="element-89">
            No es una promesa abstracta. Son escenas concretas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-90">
          {SCENES.map((scene, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="flex items-start gap-4 bg-white/10 rounded-xl p-5 border border-white/10" data-id="element-91">
              <span className="text-2xl flex-shrink-0" data-id="element-92">{scene.emoji}</span>
              <p className="text-white/90 font-medium leading-snug" data-id="element-93">
                {scene.text}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center mt-12" data-id="element-94">
          <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#C4973B] text-white font-bold py-4 px-10 rounded-full shadow-lg hover:bg-[#B08632] hover:scale-105 transition-all text-lg" data-id="element-95">
            👉 Quiero dormir tranquila hoy
          </a>
        </div>
      </div>
    </section>;
}